import react from "react";

function Loading(){
    return(
        <div className="darkbox wait" >
             <div class="loader"></div> 
        </div>
    )
}

export default Loading;


